module.exports = __webpack_public_path__ + "img/tuna-tartare.802bf882.jpg";